import { Motion } from '@/components/motion'
import { T } from '@/components/t'

export const FaqHeader = () => {
    return (
        <section className="flex w-full flex-col items-center py-7 md:py-12">
            <Motion baseDelay={0.25} y={55}>
                <div className="max-w-xl">
                    <h1 className="text-[36px] md:text-[40px] lg:text-[44px] xl:text-[48px] font-bold mb-4 text-center">
                        <T span t={'faq.hero.title'} />
                    </h1>
                </div>
            </Motion>

            <Motion baseDelay={0.45} y={70} className="mb-6">
                <T
                    p
                    t={'faq.hero.description'}
                    className="font-normal text-black/70 max-w-[700px] text-center text-[14px] md:text-[16px]"
                />
            </Motion>
        </section>
    )
}
